// Version utility that reads from environment variable injected at build time
export const getAppVersion = (): string => {
  // This environment variable is injected by Next.js at build time from package.json
  return process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0";
};

// Alternative approach (not needed anymore, but kept for reference)
// export const getAppVersionFromEnv = (): string => {
//   return process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0";
// };

// Static version (no longer needed since we have dynamic version)
// export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0";

// ✅ How This Works Now:
// Development: npm run dev → Next.js reads version from package.json → Injects as NEXT_PUBLIC_APP_VERSION
// Build: npm run build → Next.js reads version from package.json → Injects as NEXT_PUBLIC_APP_VERSION
// Version Update: npm run version:patch → Updates package.json → Next build automatically picks up new version
// Runtime: getAppVersion() → Returns process.env.NEXT_PUBLIC_APP_VERSION → Actually dynamic!
